require('./_set-species')('Array');


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/venyou-stripe/~/core-js/modules/es6.array.species.js
// module id = ../../../../core-js/modules/es6.array.species.js
// module chunks = 1